import React, {useEffect} from 'react';
import styled from 'styled-components';
import CURRENT_USER from 'api/queries/currentUser';
import {useConfirmMutation} from 'api';
import {useParams} from 'react-router';

const Confirmation = () => {
  const {token} = useParams<{token: string}>();
  const [confirm, {data, loading}] = useConfirmMutation({
    update: (cache, {data}) => {
      if (!data.confirm.error) {
        cache.writeQuery({
          query: CURRENT_USER,
          data: {currentUser: data.confirm.user},
        });

        window.location.href = '/';
      }
    },
  });

  useEffect(() => {
    confirm({variables: {token}});
  }, []);

  return (
    <Container>
      {(!data || loading) && <Title>会員登録メールアドレス確認中</Title>}
      {data && !data.confirm?.error && (
        <>
          <Title>会員登録メールアドレス確認完了</Title>

          <div className="description">
            <p>会員登録確認が完了しました</p>
          </div>
        </>
      )}
    </Container>
  );
};

export {Confirmation};

const Container = styled.div`
  padding-top: 90px;
  padding-bottom: 200px;
  text-align: center;
  width: 400px;
  margin: 0 auto;

  .description {
    margin-top: 20px;
    margin-bottom: 40px;
    font-size: 12px;
    line-height: 1.5;
    color: #2c2c2c;

    p {
      margin-bottom: 0;
    }
  }
`;

const Title = styled.h1`
  margin-bottom: 70px;
  font-size: 26px;
  font-weight: 500;
  text-align: center;
  color: #666666;
`;
